import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingRookie.css";

export default function RookieLandingPage() {
  const screenshots = [
    "/screen1.png",
    "/screen2.png",
    "/screen3.png",
    "/screen4.png",
    "/screen5.png",
  ];

  const [currentScreen, setCurrentScreen] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentScreen((prev) => (prev + 1) % screenshots.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [screenshots.length]);

  const goToRegister = () => {
    navigate("/register");
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
    });

    setMenuOpen(false);
  };

  return (
    <div className="landing rookie-landing">

      {/* =====================================================
          NAVBAR
      ====================================================== */}

      <nav className={`rookie-navbar ${menuOpen ? "menu-is-open" : ""}`}>

        <div
          className="rookie-logo"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          <img
            src="/logo-side-by-side.png"
            alt="Nessefy Logo"
            className="rookie-logo-img"
          />
        </div>

        <div className={`rookie-nav-links ${menuOpen ? "active" : ""}`}>

          <a href="#why-rookie" onClick={() => setMenuOpen(false)}>
            Why Nessefy
          </a>

          <a href="#how-rookie" onClick={() => setMenuOpen(false)}>
            How It Works
          </a>

          <a href="#community-rookie" onClick={() => setMenuOpen(false)}>
            Community
          </a>

        </div>

        <div className="rookie-nav-actions">

          <button
            className="rookie-nav-login"
            onClick={() => navigate("/login")}
          >
            Sign In
          </button>

          <button
            className="rookie-nav-btn"
            onClick={goToRegister}
          >
            Join Free
          </button>

          <button
            className={`rookie-hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

        </div>

      </nav>


      {/* =====================================================
          HERO
      ====================================================== */}

      <section className="rookie-hero">

        <div className="rookie-hero-blob rookie-blob-1"></div>
        <div className="rookie-hero-blob rookie-blob-2"></div>
        <div className="rookie-hero-blob rookie-blob-3"></div>

        <div className="rookie-hero-content">

          <p className="rookie-hero-badge">
            🌱 BUILT FOR FIRST-TIME BUILDERS
          </p>

          <h1>
            You Don't Need
            <br />
            Experience
            <br />

            <span className="rookie-highlight">
              To Start Building.
            </span>
          </h1>

          <p>
            Have an idea but don't know where to start?
            Nessefy helps aspiring entrepreneurs discover
            co-founders, mentors, investors and people who
            can help turn an idea into something real.
          </p>

          <div className="rookie-hero-buttons">

            <button
              className="rookie-primary-btn"
              onClick={goToRegister}
            >
              🚀 Start My Journey
              <span>→</span>
            </button>

            <button
              className="rookie-secondary-btn"
              onClick={() => scrollTo("how-rookie")}
            >
              See How It Works
            </button>

          </div>

          <div className="rookie-free-points">

            <span>
              <b>✓</b> Free to join
            </span>

            <span>
              <b>✓</b> No experience required
            </span>

            <span>
              <b>✓</b> Start with your idea
            </span>

          </div>

        </div>


        {/* HERO VISUAL */}

        <div className="rookie-hero-card">

          <div className="rookie-mini-card rookie-mini-1">

            <h4>💡 Have an Idea?</h4>

            <p>
              Start with what you have.
            </p>

          </div>

          <div className="rookie-mini-card rookie-mini-2">

            <h4>🤝 Find Your People</h4>

            <p>
              Build with the right people.
            </p>

          </div>


          <div className="rookie-project-card">

            <div className="rookie-project-top">

              <span>
                🚀 YOUR PROJECT
              </span>

              <div className="rookie-project-status">
                OPEN
              </div>

            </div>


            <div className="rookie-project-idea">

              <div className="rookie-idea-icon">
                💡
              </div>

              <div>

                <h3>
                  I Have an Idea.
                </h3>

                <p>
                  Now I need the right people
                  to build it with me.
                </p>

              </div>

            </div>


            <div className="rookie-project-network">

              <div className="rookie-person rookie-person-one">
                👨🏻‍💻
              </div>

              <div className="rookie-person rookie-person-two">
                👩🏻‍💼
              </div>

              <div className="rookie-person rookie-person-three">
                👨🏽‍🚀
              </div>

              <div className="rookie-person rookie-person-four">
                👩🏻‍🎨
              </div>

              <div className="rookie-network-center">
                <img
                  src="/n-logo.png"
                  alt="Nessefy"
                />
              </div>

              <div className="rookie-network-line rookie-line-one"></div>
              <div className="rookie-network-line rookie-line-two"></div>
              <div className="rookie-network-line rookie-line-three"></div>
              <div className="rookie-network-line rookie-line-four"></div>

            </div>


            <div className="rookie-project-footer">

              <span>
                💡 Idea
              </span>

              <span>
                🤝 Co-Founder
              </span>

              <span>
                💰 Investor
              </span>

              <span>
                🧭 Mentor
              </span>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          FREE STRIP
      ====================================================== */}

      <section className="rookie-free-strip">

        <div className="rookie-free-icon">
          ✓
        </div>

        <div>

          <strong>
            Your first step into business is free.
          </strong>

          <span>
            Create your profile, share your idea and
            start discovering people who can help you build.
          </span>

        </div>

        <button onClick={goToRegister}>
          Start Free →
        </button>

      </section>


      {/* =====================================================
          SHOWCASE
      ====================================================== */}

      <section className="rookie-showcase">

        <div className="rookie-showcase-content">

          <span className="rookie-showcase-tag">
            START WITH WHAT YOU HAVE
          </span>

          <h2>
            You don't need
            <br />
            a perfect plan.
            <br />

            <span>
              You need a place to start.
            </span>
          </h2>

          <p>
            Nessefy gives you a professional space to introduce
            yourself, share your project and discover people who
            could help you take your first step into business.
          </p>

          <div className="app-download-buttons">

  <a
    href="https://play.google.com/store/apps/details?id=com.niteshagarwal8290.nessefymobile"
    target="_blank"
    rel="noopener noreferrer"
    className="app-store-button"
  >
    <img
      src="./Google-Play-Icon.png"
      alt="Get it on Google Play"
      className="app-store-icon"
    />

    <span className="app-store-text">
      <small>GET IT ON</small>
      <strong>Google Play</strong>
    </span>
  </a>


  <a
    href="YOUR_APP_STORE_LINK"
    target="_blank"
    rel="noopener noreferrer"
    className="app-store-button"
  >
    <img
      src="./App-Store.png"
      alt="Download on the App Store"
      className="app-store-icon"
    />

    <span className="app-store-text">
      <small>DOWNLOAD ON THE</small>
      <strong>App Store</strong>
    </span>
  </a>

</div>


          <div className="rookie-showcase-benefits">

            <div>

              <span>01</span>

              <strong>
                Share Your Idea
              </strong>

              <p>
                Tell the community what you want to build,
                even if you're still figuring it out.
              </p>

            </div>


            <div>

              <span>02</span>

              <strong>
                Meet Experienced People
              </strong>

              <p>
                Discover founders, professionals, mentors
                and investors who can expand your perspective.
              </p>

            </div>


            <div>

              <span>03</span>

              <strong>
                Build Your First Team
              </strong>

              <p>
                Find people with skills that complement
                your own and start building together.
              </p>

            </div>

          </div>

        </div>


        {/* PHONE */}

        <div className="rookie-phone-showcase">

          <div className="rookie-floating-ui rookie-ui-one">
            💡 Share Your Idea
          </div>

          <div className="rookie-floating-ui rookie-ui-two">
            🤝 Find a Co-Founder
          </div>

          <div className="rookie-floating-ui rookie-ui-three">
            🧭 Learn From Others
          </div>

          <div className="rookie-floating-ui rookie-ui-four">
            🚀 Start Building
          </div>


          <div className="rookie-phone-frame">

            <div className="rookie-phone-notch"></div>

            <div className="rookie-phone-screen">

              <img
                key={currentScreen}
                src={screenshots[currentScreen]}
                alt="Nessefy App"
                className="rookie-phone-screenshot"
              />

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          WHY NESSEFY
      ====================================================== */}

      <section
        id="why-rookie"
        className="rookie-features"
      >

        <div className="rookie-features-header">

          <span className="rookie-features-tag">
            WHY NESSEFY FOR ROOKIES?
          </span>

          <h2>
            You may be new
            <br />
            to business.
            <br />
            <span>
              But you don't have to build alone.
            </span>
          </h2>

          <p>
            Starting your first business can feel overwhelming.
            You may have the idea but not the experience,
            connections or team. Nessefy helps bring those
            missing pieces closer to you.
          </p>

        </div>


        <div className="rookie-journey-container">

          <div className="rookie-journey-card">

            <div className="rookie-journey-step">
              01
            </div>

            <div className="rookie-journey-icon">
              💡
            </div>

            <h3>
              Start With Your Idea
            </h3>

            <p>
              You don't need a registered company or years
              of experience. Start by sharing what you want to build.
            </p>

          </div>


          <div className="rookie-journey-arrow">
            →
          </div>


          <div className="rookie-journey-card rookie-featured">

            <div className="rookie-journey-step">
              02
            </div>

            <div className="rookie-journey-icon">
              🤝
            </div>

            <h3>
              Find Your People
            </h3>

            <p>
              Discover co-founders, professionals, mentors
              and investors who could help move your idea forward.
            </p>

          </div>


          <div className="rookie-journey-arrow">
            →
          </div>


          <div className="rookie-journey-card">

            <div className="rookie-journey-step">
              03
            </div>

            <div className="rookie-journey-icon">
              🚀
            </div>

            <h3>
              Take Your First Step
            </h3>

            <p>
              Turn your idea into conversations,
              connections and eventually something real.
            </p>

          </div>

        </div>


        <div className="rookie-features-stats">

          <div>
            <h4>FREE</h4>
            <p>Start your journey</p>
          </div>

          <div>
            <h4>AI</h4>
            <p>Discover smarter connections</p>
          </div>

          <div>
            <h4>∞</h4>
            <p>Possibilities to explore</p>
          </div>

        </div>

      </section>


      {/* =====================================================
          HOW IT WORKS
      ====================================================== */}

      <section
        id="how-rookie"
        className="rookie-about"
      >

        <div className="rookie-about-content">

          <span className="rookie-about-tag">
            HOW IT WORKS
          </span>

          <h2>
            From
            <br />
            “I have an idea”
            <br />
            to
            <span>
              “Let's build it.”
            </span>
          </h2>

          <p>
            Nessefy lets you begin wherever you are.
            You don't need to have everything figured out.
            Start with your idea, discover people and learn
            as you move forward.
          </p>


          <div className="rookie-about-points">

            <div>

              <h4>
                01 — Create your profile
              </h4>

              <p>
                Introduce yourself, your interests,
                skills and what you want to build.
              </p>

            </div>


            <div>

              <h4>
                02 — Post your project
              </h4>

              <p>
                Share your idea with people who may have
                the skills, experience or resources to help.
              </p>

            </div>


            <div>

              <h4>
                03 — Connect & learn
              </h4>

              <p>
                Meet people, ask questions, find guidance
                and start building your network.
              </p>

            </div>


            <div>

              <h4>
                04 — Build something real
              </h4>

              <p>
                Take the first step toward turning
                your idea into a real business.
              </p>

            </div>

          </div>

        </div>


        {/* VISUAL */}

        <div className="rookie-about-visual">

          <div className="rookie-orbit-card rookie-orbit-one">
            💡 Idea
          </div>

          <div className="rookie-orbit-card rookie-orbit-two">
            🧑‍💻 Developer
          </div>

          <div className="rookie-orbit-card rookie-orbit-three">
            🧭 Mentor
          </div>

          <div className="rookie-orbit-card rookie-orbit-four">
            💰 Investor
          </div>

          <div className="rookie-orbit-card rookie-orbit-five">
            🤝 Co-Founder
          </div>


          <div className="rookie-center-card">

            <img
              src="/n-logo.png"
              alt="Nessefy Logo"
            />

            <h3>
              Start With an Idea
            </h3>

            <p>
              Learn • Connect • Build
            </p>

          </div>

        </div>

      </section>


      {/* =====================================================
          COMMUNITY
      ====================================================== */}

      <section
        id="community-rookie"
        className="rookie-community"
      >

        <div className="rookie-community-content">

          <span className="rookie-community-tag">
            YOUR BUSINESS JOURNEY STARTS HERE
          </span>

          <h2>
            Everyone starts
            <br />
            somewhere.
          </h2>

          <p>
            Today you might be a student with an idea.
            Tomorrow you could be a founder building a company.
            Nessefy connects you with people who can become
            part of that journey.
          </p>


          <div className="rookie-community-people">

            <div className="rookie-community-avatar">
              🎓
            </div>

            <div className="rookie-community-avatar">
              💡
            </div>

            <div className="rookie-community-avatar">
              👨🏻‍💻
            </div>

            <div className="rookie-community-avatar">
              👩🏻‍💼
            </div>

            <div className="rookie-community-avatar">
              🚀
            </div>

            <div className="rookie-community-count">
              +
            </div>

          </div>


          <div className="rookie-community-labels">

            <span>
              Students
            </span>

            <span>
              First-Time Builders
            </span>

            <span>
              Aspiring Entrepreneurs
            </span>

            <span>
              Creators
            </span>

            <span>
              Future Founders
            </span>

          </div>

        </div>

      </section>


      {/* =====================================================
          FINAL CTA
      ====================================================== */}

      <section className="rookie-final-cta">

        <div className="rookie-final-content">

          <span className="rookie-final-tag">
            YOUR FIRST STEP
          </span>

          <h2>
            You have an idea.
            <br />
            That's enough
            <br />
            to start.
          </h2>

          <h3>
            Start your journey on
            <span>
              Nessefy.
            </span>
          </h3>

          <p>
            Create your profile, share what you're building
            and start meeting people who can help you turn
            your idea into something real.
          </p>


          <button
            className="rookie-final-button"
            onClick={goToRegister}
          >
            🚀 Start My Journey
            <span>
              — It's Free
            </span>
          </button>


          <div className="rookie-final-free-line">

            ✓ Free to join

            <span>•</span>

            ✓ No experience required

            <span>•</span>

            ✓ Start with your idea

          </div>

        </div>


        <div className="rookie-final-card">

          <div className="rookie-final-card-icon">
            🌱
          </div>

          <span>
            EVERY BUILDER STARTS SOMEWHERE.
          </span>

          <h3>
            Your idea
            <br />
            could be
            <br />

            <strong>
              the beginning.
            </strong>
          </h3>

          <p>
            You don't need to know everything.
            You just need to take the first step.
          </p>

          <button
            onClick={goToRegister}
          >
            Create My Free Profile →
          </button>

        </div>

      </section>


      {/* =====================================================
          FOOTER
      ====================================================== */}

      <footer className="rookie-footer">

        <p>
          © 2026 Nessefy. All rights reserved.
        </p>

        <div className="rookie-footer-links">

          <span
            onClick={() => navigate("/privacy-policy")}
          >
            Privacy Policy
          </span>

          <span
            onClick={() => navigate("/terms-and-conditions")}
          >
            Terms & Conditions
          </span>

        </div>

      </footer>

    </div>
  );
}